export default "images/lunwen.png";